import { useEffect, useState } from "react";
import { getOrders } from "@/api/customer.api.js";
import { useAuth } from "@/auth/AuthContext.jsx";
import { isActiveCustomerOrder } from "@/utils/orderProgress.js";
import { ROLES } from "@/utils/constants.js";

export function useHomeActiveOrders() {
    const { isAuthenticated, role } = useAuth();
    const [orders, setOrders] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const isCustomer = isAuthenticated && role === ROLES.CUSTOMER;

    useEffect(() => {
        if (!isCustomer) {
            setOrders([]);
            setLoaded(true);
            return undefined;
        }

        let cancelled = false;
        setLoaded(false);
        getOrders()
            .then((response) => {
                if (cancelled) {
                    return;
                }
                const active = (response.data || []).filter((order) => isActiveCustomerOrder(order.status));
                setOrders(active);
            })
            .catch(() => {
                if (!cancelled) {
                    setOrders([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoaded(true);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [isCustomer]);

    return { orders, isCustomer, loaded };
}
